/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignInstallersToCompanyRequestModel,
  BadRequest,
  Conflict,
  Forbidden,
  InstallerCompaniesResponseModel,
  InstallerCompanyRequestModel,
  InstallerCompanyResponseModel,
  NotFound,
  Unauthorized,
} from '../models';

export interface InstallerCompaniesAssignInstallersToInstallerCompanyRequest {
    installerCompanyId: string;
    assignInstallersToCompanyRequestModel: AssignInstallersToCompanyRequestModel;
}

export interface InstallerCompaniesDeleteInstallerCompanyRequest {
    id: string;
}

export interface InstallerCompaniesGetInstallerCompaniesRequest {
    page?: number;
    limit?: number;
    tenantId?: string;
}

export interface InstallerCompaniesGetInstallerCompanyRequest {
    companyId: string;
}

export interface InstallerCompaniesSetInstallerCompanyRequest {
    installerCompanyRequestModel: InstallerCompanyRequestModel;
}

/**
 * 
 */
export class InstallerCompaniesApi extends runtime.BaseAPI {

    /**
     * Assigns one or more installer users to an installer company. Creates employment/contractor relationships for managing installation work assignments and service territories
     * Assign Installers to Company
     */
    async installerCompaniesAssignInstallersToInstallerCompanyRaw(requestParameters: InstallerCompaniesAssignInstallersToInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installerCompanyId === null || requestParameters.installerCompanyId === undefined) {
            throw new runtime.RequiredError('installerCompanyId','Required parameter requestParameters.installerCompanyId was null or undefined when calling installerCompaniesAssignInstallersToInstallerCompany.');
        }

        if (requestParameters.assignInstallersToCompanyRequestModel === null || requestParameters.assignInstallersToCompanyRequestModel === undefined) {
            throw new runtime.RequiredError('assignInstallersToCompanyRequestModel','Required parameter requestParameters.assignInstallersToCompanyRequestModel was null or undefined when calling installerCompaniesAssignInstallersToInstallerCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/installer-companies/{installerCompanyId}/assignInstaller`.replace(`{${"installerCompanyId"}}`, encodeURIComponent(String(requestParameters.installerCompanyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.assignInstallersToCompanyRequestModel,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assigns one or more installer users to an installer company. Creates employment/contractor relationships for managing installation work assignments and service territories
     * Assign Installers to Company
     */
    async installerCompaniesAssignInstallersToInstallerCompany(requestParameters: InstallerCompaniesAssignInstallersToInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.installerCompaniesAssignInstallersToInstallerCompanyRaw(requestParameters, initOverrides);
    }

    /**
     * Removes an installer company from the system. This action permanently deletes the company record and unassigns all associated installers. Cannot be undone. Requires no active installations linked to the company
     * Delete Installer Company
     */
    async installerCompaniesDeleteInstallerCompanyRaw(requestParameters: InstallerCompaniesDeleteInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling installerCompaniesDeleteInstallerCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/installer-companies/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes an installer company from the system. This action permanently deletes the company record and unassigns all associated installers. Cannot be undone. Requires no active installations linked to the company
     * Delete Installer Company
     */
    async installerCompaniesDeleteInstallerCompany(requestParameters: InstallerCompaniesDeleteInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.installerCompaniesDeleteInstallerCompanyRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a paginated list of installer companies with optional filtering capabilities. Returns company details including business information, assigned installers count, and service areas. Supports tenant-scoped queries
     * Get Installer Companies
     */
    async installerCompaniesGetInstallerCompaniesRaw(requestParameters: InstallerCompaniesGetInstallerCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallerCompaniesResponseModel>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenant_id'] = requestParameters.tenantId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/installer-companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a paginated list of installer companies with optional filtering capabilities. Returns company details including business information, assigned installers count, and service areas. Supports tenant-scoped queries
     * Get Installer Companies
     */
    async installerCompaniesGetInstallerCompanies(requestParameters: InstallerCompaniesGetInstallerCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallerCompaniesResponseModel> {
        const response = await this.installerCompaniesGetInstallerCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves detailed information for a specific installer company. Returns complete company profile including business details, assigned installers, service areas, and operational status
     * Get Installer Company by ID
     */
    async installerCompaniesGetInstallerCompanyRaw(requestParameters: InstallerCompaniesGetInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallerCompanyResponseModel>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling installerCompaniesGetInstallerCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/installer-companies/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves detailed information for a specific installer company. Returns complete company profile including business details, assigned installers, service areas, and operational status
     * Get Installer Company by ID
     */
    async installerCompaniesGetInstallerCompany(requestParameters: InstallerCompaniesGetInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallerCompanyResponseModel> {
        const response = await this.installerCompaniesGetInstallerCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new installer company in the system. Registers company details including business information, contact data, and service area for managing installation service providers
     * Add New Installer Company
     */
    async installerCompaniesSetInstallerCompanyRaw(requestParameters: InstallerCompaniesSetInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstallerCompaniesResponseModel>> {
        if (requestParameters.installerCompanyRequestModel === null || requestParameters.installerCompanyRequestModel === undefined) {
            throw new runtime.RequiredError('installerCompanyRequestModel','Required parameter requestParameters.installerCompanyRequestModel was null or undefined when calling installerCompaniesSetInstallerCompany.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/installer-companies`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.installerCompanyRequestModel,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new installer company in the system. Registers company details including business information, contact data, and service area for managing installation service providers
     * Add New Installer Company
     */
    async installerCompaniesSetInstallerCompany(requestParameters: InstallerCompaniesSetInstallerCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstallerCompaniesResponseModel> {
        const response = await this.installerCompaniesSetInstallerCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
